module.exports = new __parcel__URL__("app-requests-empty-state.0e3171a7.svg").toString();